"use client";

import { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import Hero from "../components/referrals-tutorial/Hero";
import WhatYouGet from "../components/referrals-tutorial/WhatYouGet";
import FreePDFSection from "../components/referrals-tutorial/FreePDFSection";
import PeerQuikPromo from "../components/referrals-tutorial/PeerQuikPromo";
import FAQ from "../components/referrals-tutorial/FAQ";
import ReferralTimeSaver from "../components/referrals-tutorial/TimeSaver";

const stripePromise = loadStripe(
  process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY!
);

export default function ReferralsTutorialContent() {
  const [isLoading, setIsLoading] = useState(false);
  const [couponCode, setCouponCode] = useState("");

  useEffect(() => {
    // Get coupon from URL if present
    const urlParams = new URLSearchParams(window.location.search);
    const urlCoupon = urlParams.get("coupon");
    if (urlCoupon) {
      setCouponCode(urlCoupon);
    }
  }, []);

  const handlePurchase = async (customCoupon?: string) => {
    setIsLoading(true);

    try {
      // Get referral code from URL if present
      const urlParams = new URLSearchParams(window.location.search);
      const referralCode = urlParams.get("ref");

      // Use custom coupon if provided, otherwise use state coupon
      const finalCoupon = customCoupon !== undefined ? customCoupon : (couponCode || null);

      const response = await fetch("/api/referrals-tutorial/checkout", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          referralCode: referralCode || null,
          couponCode: finalCoupon
        }),
      });

      const { sessionId, error } = await response.json();

      if (error) {
        alert(error);
        setIsLoading(false);
        return;
      }

      const stripe = await stripePromise;
      if (!stripe) {
        alert("Stripe failed to load");
        setIsLoading(false);
        return;
      }

      const { error: stripeError } = await stripe.redirectToCheckout({
        sessionId,
      });

      if (stripeError) {
        alert(stripeError.message);
        setIsLoading(false);
      }
    } catch (err) {
      console.error("Purchase error:", err);
      alert("Something went wrong. Please try again.");
      setIsLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-black">
      <Hero
        onPurchase={handlePurchase}
        isLoading={isLoading}
        couponCode={couponCode}
        setCouponCode={setCouponCode}
      />
      <WhatYouGet />
      <ReferralTimeSaver />
      <FreePDFSection />

      {/* Secondary CTA */}
      <section className="bg-black text-white py-12 px-4">
        <div className="max-w-2xl mx-auto text-center">
          <h3 className="text-2xl md:text-3xl font-bold mb-6">
            Ready to build your referral system?
          </h3>
          <button
            onClick={() => handlePurchase()}
            disabled={isLoading}
            className={`bg-cyan-400 hover:bg-cyan-300 text-black font-bold py-4 px-12 rounded-full text-xl transition-all hover:scale-105 shadow-lg shadow-cyan-400/20 ${
              isLoading ? "opacity-60 cursor-not-allowed" : ""
            }`}
          >
            {isLoading ? "Processing..." : "Get Full Access — $9.99"}
          </button>
          <p className="text-sm text-gray-400 mt-4">
            Complete source code · Instant delivery · No refunds
          </p>
        </div>
      </section>

      <PeerQuikPromo />
      <FAQ />
    </main>
  );
}
